<template>
  <div class="flex">
    <input
      :id="field.handle"
      :name="name"
      type="checkbox"
      class="
        form-checkbox peer bg-transparent rounded
        focus:ring-0 focus-visible:ring-0 focus:outline-0 focus-visible:outline-0 focus:border-purple-dark
      "
      :required="rules.includes('required')"
      @change="emits('update', $event)"
    >

    <label
      :for="field.handle"
      v-html="label"
      class="-mt-0.5 ml-2 text-purple-dark leading-none md:text-lg"
    />
  </div>
</template>

<script setup lang="ts">
import type { Field } from '~/statamic/types/form';

defineProps<{
  name: string;
  field: Field;
  rules: string[];
  label?: string;
}>();

const emits = defineEmits([
  'update',
]);
</script>
